import { usePublicTranslation } from "@/features/utils/i18n";
import { ArrowRight } from "@phosphor-icons/react";

interface TransferSeparatorProps {
  fromAgentName?: string;
  toAgentName?: string;
}

export function TransferSeparator({
  fromAgentName,
  toAgentName,
}: TransferSeparatorProps) {
  const { t } = usePublicTranslation();
  return (
    <div className="flex items-center gap-3 my-6 text-xs text-muted-foreground">
      <div className="flex-1 h-px bg-border" />
      <div className="flex items-center gap-2 px-3 py-1.5 bg-muted/50 rounded-full border">
        <span className="font-medium">
          {fromAgentName || t("chat.transfer_from")}
        </span>
        <ArrowRight size={14} weight="bold" />
        <span className="font-medium">
          {toAgentName || t("chat.transfer_to")}
        </span>
      </div>
      <div className="flex-1 h-px bg-border" />
    </div>
  );
}
